/* em-form-check.js - the prototype's inline form checks (em-form.js) for the site's Shopify forms (.emf): a field
   left empty or an email that doesn't look right gets one line under the form and the focus, instead of the
   browser's bubble. A form that passes posts to Shopify as usual. Sept 14 (QA). */
(function () {
  'use strict';
  function labelFor(f) {
    var row = f.closest('.emf-row'), l = row && row.querySelector('label');
    return l ? l.textContent.trim().toLowerCase() : 'this field';
  }
  function boot() {
    [].forEach.call(document.querySelectorAll('form.emf'), function (form) {
      if (form._emCheck) return; form._emCheck = true;
      form.setAttribute('novalidate', 'novalidate');
      var err = form.querySelector('.emf-err');
      if (!err) { err = document.createElement('p'); err.className = 'emf-err'; err.setAttribute('role', 'alert'); var b = form.querySelector('button[type="submit"]'); form.insertBefore(err, b || null); }
      form.addEventListener('submit', function (e) {
        var bad = null;
        [].forEach.call(form.querySelectorAll('input,textarea,select'), function (f) {
          if (f.type === 'hidden') return;
          f.removeAttribute('aria-invalid');
          var v = (f.value || '').trim();
          if (f.required && !v) bad = bad || { f: f, why: 'Fill in ' + labelFor(f) + '.' };
          else if (f.type === 'email' && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) bad = bad || { f: f, why: 'That email address does not look right.' };
        });
        if (bad) {
          e.preventDefault();
          bad.f.setAttribute('aria-invalid', 'true');
          err.textContent = bad.why;
          bad.f.focus();
          return;
        }
        err.textContent = '';
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.setAttribute('data-label', btn.textContent); btn.textContent = 'Sending…'; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
